export const exposureGroupRegex = /\b\w+(?:_\w+)*\b/g;
